import { ComponentIdSpan } from '@inter-ikea-core/core';

export const HIDE_OCCLUDING_OBJECTS_COMPONENTS_BASE_ID =
  ComponentIdSpan.SPACE_PLANNER_BASE_ID + 175;

export const STORAGEONE_INTEGRATION_COMPONENTS_BASE_ID =
  ComponentIdSpan.SPACE_PLANNER_BASE_ID + 200;

export enum HideOccludingObjectsComponentIds {
  FADE_MATERIAL_COMPONENT_ID = HIDE_OCCLUDING_OBJECTS_COMPONENTS_BASE_ID,
  FADE_ANIMATION_COMPONENT_ID = HIDE_OCCLUDING_OBJECTS_COMPONENTS_BASE_ID + 1
}
